module.exports = __webpack_public_path__ + "static/media/ba.425d1f8c.svg";